export default {
    "common.Accept": "受け入れる",
    "common.Add"   : "追加する",
    "common.Cancel": "キャンセル",
    "common.Close" : "閉じる",
    "common.Delete": "削除する",
    "common.Save"  : "保存",
    "common.accept": "受け入れる",
    "common.add"   : "追加する",
    "common.cancel": "キャンセル",
    "common.close" : "閉じる",
    "common.delete": "削除",
    "common.save"  : "保存",
    "action.accept": "受け入れる",
    "action.add": "追加",
    "action.addCheckpoint": "チェックポイントの追加",
    "action.addCondition": "条件を追加する",
    "action.addNewRule": "新規ルールの追加",
    "action.addToCalendar": "カレンダーに追加",
    "action.allowReplies": "返信を許可する",
    "action.allowRepliesAll": "すべての返信を許可",
    "action.allowForward": "転送を許可する",
    "action.archive": "アーカイブ",
    "action.attach": "添付する",
    "action.cancel": "キャンセル",
    "action.clearCache": "キャッシュクリア",
    "action.close": "閉じる",
    "action.createNewType": "新しいタイプを作成する",
    "action.delete": "削除",
    "action.enable": "有効にする",
    "action.deselect": "選択解除",
    "action.Download": "ダウンロード",
    "action.form.addField": "フォーム",
    "action.form.RemoveField": "フォーム",
    "action.Forward": "進む",
    "action.forward": "転送",
    "action.HideRecipients": "受信者を隠す",
    "action.highlightPost": "投稿をハイライトする",
    "action.logout": "ログアウト",
    "action.markRead": "既読マーク",
    "action.markUnread": "未読マーク",
    "action.notify": "通知",
    "action.pay": "支払う",
    "action.post.addAttachment": "投稿",
    "action.redact": "再編集",
    "action.repeatEvery": "毎回繰り返す",
    "action.repeatOn": "繰り返しオン",
    "action.reply": "返信",
    "action.replyAll": "すべて返信",
    "action.restore": "リストア",
    "action.schedulePublishDate": "スケジュール公開日",
    "action.scheduleExpirationDate": "スケジュール有効期限",
    "action.save": "保存",
    "action.select": "選択",
    "action.send": "送信",
    "action.sendAnswers": "回答を送信",
    "action.sendAnswer": "回答を送信",
    "action.Share": "共有",
    "action.slideGps": "スライドGps",
    "action.undo": "元に戻す",
    "action.tapHereToUploadFiles": "タップしてファイルをアップロードする",
    "adj.allDay": "終日",
    "adj.Appreciation.expelled": "感謝退場",
    "adj.Appreciation.mustRepeat": "感謝は繰り返さなければならない",
    "adj.Appreciation.promoted": "感謝される",
    "adj.Appreciation.toDefine": "感謝を定義する",
    "adj.ends": "終わる",
    "adj.everyDay": "毎日",
    "adj.everyMonth": "毎月",
    "adj.everyWeek": "毎週",
    "adj.everyYear": "毎年",
    "adj.notIssued.plural": "発行されていない複数形",
    "adj.read.plural": "複数回読む",
    "adj.repeats": "繰り返す",
    "adj.selected": "選択された",
    "adj.statusActive": "現役",
    "adj.statusGraduated": "ステータス卒業",
    "adj.statusInactive": "非アクティブ",
    "adj.statusInscribed": "ステータス内接",
    "adj.statusPending": "保留",
    "adj.statusSuspended": "資格停止",
    "adj.statusWithdrawn": "資格停止中",
    "adj.unread.plural": "未読",
    "adj.unread.singular": "未読",
    "atendant": "付添人",
    "aunt": "叔母",
    "brother": "兄弟",
    "published": "掲載",
    "notice.toMe": "私にとって",
    "component.phi.debit.expirationDate": "有効期限",
    "component.phi.debit.interests": "利息",
    "component.phi.debit.issueDate": "発行日",
    "condition.attributes.between": "の間に",
    "condition.attributes.contains": "を含む",
    "condition.attributes.document": "文書",
    "condition.attributes.equalTo": "等しい",
    "condition.attributes.firstName": "名前",
    "condition.attributes.gender": "性別",
    "condition.attributes.greaterThan": "より大きい",
    "condition.attributes.lastName": "姓",
    "condition.attributes.lessThan": "より小さい",
    "condition.attributes.startsWith": "で始まる",
    "transport.whatsapp": "WhatsApp",
}